<template>
  <div>
    <h1>{{text}}</h1>
    <h3>카카오 로그인 샘플</h3>
    <button @click="KakaoLogin">카카오 로그인</button>
    <button @click="$emit('close')">Close</button>
  </div>
</template>

<script>
//import axios from 'axios'
//import * as KakaoUtil from '@/utils/Kakao.js'

export default {
  name: 'KakaoLoginSample',
  methods:{
    KakaoLogin() {
      window.Kakao.init('7a9a38f6f0e2a713942f48931695322f');
      window.location.replace("https://kauth.kakao.com/oauth/authorize?client_id=7a9a38f6f0e2a713942f48931695322f&redirect_uri=http://localhost:8081/KakaoLoginPage&response_type=code");
      
      // window.Kakao.Auth.authorize({
      //   redirectUri: "http://localhost:8081/auth/kakao/KakaoLoginPage",
      // });
    }
  }
}
</script>